import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FeedbackDashboard } from '../features/interview';
import { vibeService } from '../services/VibeService';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [feedbackData, setFeedbackData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    vibeService.trigger('loading');
    // Load feedback data from localStorage or API
    const loadFeedbackData = () => {
      try {
        const savedFeedback = localStorage.getItem('interviewFeedback');
        if (savedFeedback) {
          setFeedbackData(JSON.parse(savedFeedback));
        }
      } catch (error) {
        console.error('Error loading feedback data:', error);
      } finally {
        setLoading(false);
        vibeService.dismiss();
      }
    };

    loadFeedbackData();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (!feedbackData) {
    vibeService.trigger('bored');
    return (
      <div className="dashboard-page">
        <div className="no-data-container">
          <h2>No Interview Data</h2>
          <p>You haven't completed any interviews yet.</p>
          <button 
            className="btn-primary"
            onClick={() => navigate('/interview')}
          >
            Start Your First Interview
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <FeedbackDashboard 
        feedbackData={feedbackData}
        candidateName="User"
        interviewMessages={[]}
        onClose={() => {}}
        onPlayAudio={() => {}}
      />
    </div>
  );
};

export default Dashboard;
